import React, { useEffect } from 'react';
import { Table, Typography, Card, Row, Col, Divider, Button } from 'antd';
import { inventoryData } from '../../data/sampleData';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const InventoryReport = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        navigate('/reports');
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [navigate]);

  const columns = [
    { title: 'Medicine ID', dataIndex: 'id', key: 'id' },
    { title: 'Medicine Name', dataIndex: 'name', key: 'name' },
    { title: 'Quantity Available', dataIndex: 'quantity', key: 'quantity' },
    { title: 'Supplier', dataIndex: 'supplier', key: 'supplier' },
  ];

  return (
    <Row justify="center" style={{ padding: '24px' }}>
      <Col span={24} md={20} lg={16}>
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/reports')}
          style={{ marginBottom: 16 }}
        >
          Back
        </Button>
        <Card
          title={<Title level={3} style={{ marginBottom: 0 }}>📦 Inventory Report</Title>}
          bordered={false}
          style={{ boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}
        >
          <Text type="secondary">Overview of current stock and suppliers</Text>
          <Divider />
          <Table
            dataSource={inventoryData}
            columns={columns}
            rowKey="id"
            pagination={{ pageSize: 5 }}
            bordered
          />
        </Card>
      </Col>
    </Row>
  );
};

export default InventoryReport;
